import { Component } from '@angular/core';
import { ErrorNotificationComponent } from '@components/error-notification/error-notification.component';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-consultation-navigation-restricted-error',
  imports: [ErrorNotificationComponent],
  templateUrl: './consultation-navigation-restricted-error.component.html',
})
export class ConsultationNavigationRestrictedErrorComponent {
  /**
   * Gets the contact email address from the application configuration.
   *
   * @returns {string} the configured support email address
   */
  public get contactEmail(): string {
    return environment.email;
  }
}
